(() => {
 
  const displayActive = (variantId) => {
    const alerts = document.querySelectorAll('.product-inventory__wrapper--custom')
    alerts.forEach(alert => {
      const classes = [...alert.classList]
      classes.includes(`product-inventory__variant--${variantId}`) ? alert.style.display = 'block' : alert.style.display = 'none'
    })
  }

  const displayActiveOnload = () => {
    const urlParams = new URLSearchParams(window.location.search)
    let activeVariant = urlParams.get('variant')
    
    if (activeVariant == null) {
      const firstAlert = document.querySelector('.product-inventory__wrapper--custom')
      activeVariant = [...firstAlert.classList][1].split('--').pop()
    }
  
    displayActive(activeVariant)
  }

  const runMain = () => {
    displayActiveOnload()

    const variantButtons = document.querySelectorAll('.product-form__variant-label--custom')
    variantButtons.forEach(button => {
      button.addEventListener('click', () => displayActive(button.dataset.variantId))
    })
  }
  
  window.onload = () => runMain()
  
})()